import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  LinearProgress,
} from '@material-ui/core';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  editStoreCustomerDefaultGroupApi,
  getStoreCustomerDefaultGroupApi
} from 'api';


const DefaultCustomerGroup = () => {
  const dispatch = useDispatch();
  const { customerDefaultGroup, loadingCustomerDefaultGroup } = useSelector((state: IReduxState) => state.customers);

  useEffect(() => {
    if (Object.keys(customerDefaultGroup).length === 0) {
      getStoreCustomerDefaultGroupApi({ dispatch });
    }
  }, [dispatch, customerDefaultGroup]);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          isCapitalize={Boolean(false)}
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Go Live Requirements', path: '/settings#go_live_requirements' },
            { name: 'Default Customer Group' },
          ]}
        />
      </div>
      <Card className="mx-10 my-8 overflow-visible">
        {loadingCustomerDefaultGroup && <LinearProgress className="mt-10 mx-10" />}
        {!loadingCustomerDefaultGroup && Object.keys(customerDefaultGroup).length === 0 && (
          <div className="m-10">Can&apos;t fetch Default Customer Group</div>
        )}
        {!loadingCustomerDefaultGroup && (
          <Formik
            enableReinitialize
            initialValues={{
              customer_group: customerDefaultGroup?.code || ''
            }}
            validationSchema={yup.object({
              customer_group: yup.string()
                .max(32, 'Maximum length must be less than 32 characters')
                .required('Field is required'),
            })}
            onSubmit={async (values) => {
              await editStoreCustomerDefaultGroupApi({
                dispatch,
                id: customerDefaultGroup.id,
                group: {
                  code: values.customer_group,
                  tax_class_id: customerDefaultGroup.tax_class_id,
                },
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              isValid,
              dirty,
              handleBlur,
              handleChange,
              handleSubmit
            }) => (
              <form noValidate className="p-8" onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <p className="text-gray">
                      In this section, you can check or edit the Default Customer Group Name in your store
                    </p>
                  </Grid>
                </Grid>
                <Divider className="my-4" />
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={3} md={3}>
                    <Typography variant="h6" className="text-gray">
                      Default Customer Group Name:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={9} md={9}>
                    <TextField
                      fullWidth
                      required
                      variant="outlined"
                      value={values.customer_group}
                      name="customer_group"
                      label="Default Customer Group"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.customer_group && Boolean(errors.customer_group)}
                      helperText={touched.customer_group && errors.customer_group}
                    />
                    <div className="flex justify-end items-center w-full py-5">
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={!(isValid && dirty)}
                        className="w-full max-w-150"
                      >
                        Save
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        )}
      </Card>
      <BackdropCircular loading={loadingCustomerDefaultGroup} />
    </div>
  );
};

export default DefaultCustomerGroup;
